import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid2 as Grid, Stack} from 'views/components';

import FilterBar from './scene/filter/FilterBar';
import Header from './scene/Header';
import List from './scene/list/List';
import {generateFilterOptions} from './scene/filter/FilterGenerator';

const filterOptions = generateFilterOptions();

const defaultSelection = () => {
  return {
    order: {orderBy: 'creationTime', orderDirc: 'DESC'},
    filter: {
      status: {
        filterData: filterOptions['status'],
        optionSelected: 'ACTIVE',
      },
    },
  };
};

const ClientList = (props) => {
  const [reload, setReload] = React.useState(0);
  const [lastUpdatedAt, setLastUpdatedAt] = React.useState(new Date());
  const [selection, setSelection] = React.useState(defaultSelection());

  const resetFilter = () => {
    setSelection(defaultSelection());
  };

  const updateFilter = (filter, option) => {
    setSelection((e) => {
      if (option) {
        return {
          ...e,
          filter: {
            ...e.filter,
            [filter.key]: {
              filterData: filter,
              optionSelected: option.key,
            },
          },
        };
      } else {
        const newFilter = {...e.filter};
        delete newFilter[filter.key];
        return {
          ...e,
          filter: newFilter,
        };
      }
    });
  };

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Header
          lastUpdatedAt={lastUpdatedAt}
          numRefresh={reload}
          setLastUpdatedAt={setLastUpdatedAt}
          setNumRefresh={setReload}
        />
      </Grid>
      <Grid size={12}>
        <Stack spacing={4} width={1} pb={{xs: 0, md: 2}}>
          <FilterBar
            selection={selection}
            filterOptions={filterOptions}
            updateFilter={updateFilter}
            onClearFilter={resetFilter}
          />
          <List
            selection={selection}
            reload={reload}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};
ClientList.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(ClientList));
